<template>

    <v-card >

        <v-divider></v-divider>
        <v-card-text style="max-height: 120%;">
            <v-row>

              
              <v-col cols="12" class="d-flex justify-end mb-2">
                <v-btn  color="primary" class="mx-2" @click="exportToCSV">
                  {{$t('comun.boton_exportar')}} {{ nombre_fila }}
                </v-btn>
                
                <v-btn :disabled="this.disabled" color="primary" class="mx-2" @click="importFromCSV">
                  {{$t('comun.boton_importar')}} {{ nombre_fila }}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleCSVUpload"
                  />
                </v-btn>
              </v-col>
              


            <v-col cols="12">
               
            <div class="tabla-container scroll-container">
              <table class="value-table">
              <thead>
                <tr>
                  <th class="label-col"></th>
                  <th
                    v-for="(year) in years"
                    :key="year"
                    class="year-col"
                    
                  >
                    {{ year }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="nombre in this.nombres_fila" :key="nombre">
                  <td class="label-col label-cell">
                   
                    <span >{{ this.nombres_tabla[nombre.toLowerCase()] }}</span>
                  </td>
                  <td
                    v-for="(year, index) in years"
                    :key="year"
                    class="data-cell"
                    :class="{ 'col-odd': index % 2 !== 0 }"
                  >
                  
                    <input
                     :disabled="this.disabled"
                      :value="formatNumber(datos.find(item => item.anio === year)?.[nombre.toLowerCase()])"
                      class="data-input"
                     @input="event => {
                          const val = event.target.value.replace(',', '.');
                          const item = datos.find(d => d.anio === year);
                          if (item) item[nombre.toLowerCase()] = val === '' ? null : Number(val);
                        }"
                    />
                    
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
        </v-col>
      </v-row>

    </v-card-text>
    </v-card>


</template>

<script>
//import VGrid from "@revolist/vue3-datagrid";
//import axios from 'axios';
//import store from '../store';
//import ComponenteLoading from './ComponenteLoading.vue';
export default {

  props: {
    disabled:{
      type:Boolean,
      default:false,
    },  
    modelValue: {
      type: Array,
      required: true,
    },

    years:{
      type:Array,
      required :true,
    },
    nombres_fila:{
      type:Array,
      required:true
    },
    nombre_tabla:{
      type:String,
      default:"",
    },
    nombres_tabla:{
      type:Object,
      default:()=>{},
    },
    
  },

  data() {
    return {
      loading: false,
      anio_min:2025,
      anio_max:2100,
      first_index:0,
      last_index:50,
      columns: [
        { name: this.$t('simulacion.modulo.demanda.tabla.id'),  prop: "id", size: 90, readonly: true },
        { name: this.$t('simulacion.modulo.demanda.tabla.dH2Ob'),  prop: "dH2VOb", size: 250  },
        { name: this.$t('simulacion.modulo.demanda.tabla.pcH2Ob'),  prop: "pcH2VOb", size: 300  },
        { name: this.$t('simulacion.modulo.demanda.tabla.dH2Op'),  prop: "dH2VOp", size: 250  },
        { name: this.$t('simulacion.modulo.demanda.tabla.pcH2Op'),  prop: "pcH2VOp", size: 250  },
      ],


      columnasEsperadas:{
      id: [this.$i18n.messages.es.simulacion.modulo.demanda.tabla.id, this.$i18n.messages.en.simulacion.modulo.demanda.tabla.anio],
      dH2VOb: [this.$i18n.messages.es.simulacion.modulo.demanda.tabla.dH2Ob, this.$i18n.messages.en.simulacion.modulo.demanda.tabla.dH2Ob],
      pcH2VOb: [this.$i18n.messages.es.simulacion.modulo.demanda.tabla.pcH2Ob,this.$i18n.messages.en.simulacion.modulo.demanda.tabla.pcH2Ob],
      dH2VOp: [this.$i18n.messages.es.simulacion.modulo.demanda.tabla.dH2Op, this.$i18n.messages.en.simulacion.modulo.demanda.tabla.dH2Op],
      pcH2VOp: [this.$i18n.messages.es.simulacion.modulo.demanda.tabla.pcH2Op, this.$i18n.messages.en.simulacion.modulo.demanda.tabla.pcH2Op],
    
    },


      datos: [...this.modelValue],
    
     /*  local_infl:{...this.infl}, */

      rules: {
        required: (v) => !!v || "Este campo es obligatorio",
        minYear: (value) => value >= this.min_year || `El año debe ser mayor o igual a ${this.min_year}`,
         Negativo: (v) => {
        const num = Number(v.toString().replace(',', '.'));
          return isNaN(num) ? 'Valor inválido' : (num >= 0 ? true : 'El valor no puede ser negativo');
        },
      },
    };
  },

  components: {
    //VGrid,
    //ComponenteLoading,
  },

  watch: {
    datos_generales:{
      handler(){
        console.log("Actualizado ANIO INICIO"),
      this.first_index=this.datos_generales.anio_inicio-this.anio_min
      this.last_index=this.datos_generales.anio_fin-this.anio_min+1
      }
      
    //this.actualizarAnios();
    },

    local_infl:{
      handler(newDatos) {        
        this.$emit('update:infl', newDatos);
      },      
      immediate: true,
      deep: true,
    },
    '$i18n.locale'() {     
      
      this.columns = [
        { name: this.$t('simulacion.modulo.demanda.tabla.id'),  prop: "id", size: 90, readonly: true },
        { name: this.$t('simulacion.modulo.demanda.tabla.dH2Ob'),  prop: "dH2VOb", size: 250  },
        { name: this.$t('simulacion.modulo.demanda.tabla.pcH2Ob'),  prop: "pcH2VOb", size: 300  },
        { name: this.$t('simulacion.modulo.demanda.tabla.dH2Op'),  prop: "dH2VOp", size: 250  },
        { name: this.$t('simulacion.modulo.demanda.tabla.pcH2Op'),  prop: "pcH2VOp", size: 250  },
      ];


    },
    modelValue(newVal) {
    this.datos = [...newVal]; // O con deep clone si es necesario
    },
  



  },
computed:{

    

  local_infl: {
    get() {
      return this.infl;
    },
    set(newDatos) {
        console.log("Set de local_infl", newDatos)
      /* this.$emit('update:infl', newDatos); */
    }
  },
  INFL: {
      get() {        
        const value = this.local_infl.inflacion  
        return (value * 100).toFixed(2)               
      },
      set(value) {        
        const numericValue = value / 100;
        this.local_infl.inflacion = isNaN(numericValue) ? 0 : numericValue;
      },
    },
    INFL_formatted: {
    get() {
      return this.formatNumber(this.INFL);
    },
    set(val) {
      const numeric = val.replace(',', '.');
      this.INFL = Number(numeric);
    }
    }
},
methods: {
      getCellDisplay(year) {
      const val = this.datosMap[year];
      if (val === undefined || val === null || val === '') return '';
      if (typeof val === 'number') {
        return val === 0
          ? '0'
          : val.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 20 });
      }
      return val;
    },
  //Activar demanda opcional en cálculo LCOH, todos los valores a 100000
  activarDemandaOpcionalLCOH(){
    console.log("Activado")
  },
  desactivarDemandaOpcionalLCOH(){
    console.log("Activado")
  },

  formatNumber(value) {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value !== 'number') value = Number(value);

  if (Number.isInteger(value)) {
    return value.toString().replace('.', ',');
  } else {
    return value.toString().replace('.', ',');
  }
},
  calcularInflacion(){
    console.log("inflacion: ",this.infl.inflacion, " ",this.infl.pr_H2VOb, " ",this.infl.pr_H2VOp )
    
    this.$emit('inflacion','Calcular_inflacion')
  },
  
 
    handleCellEdit(event) {
      
      console.log("Intercepta...");

      // Acceder al detalle del evento
      const { detail } = event;

      // Convertir a número si la columna es "valor"
      if (detail.prop === "valor") {
        const newValue = Number(detail.val);

        // Actualizar el modelo de la fila correspondiente
        const rowIndex = detail.rowIndex;
        this.datos[rowIndex][detail.prop] = newValue;

        // Confirmación en consola
        console.log(`Fila actualizada (${rowIndex}):`, this.datos[rowIndex]);
      }
    },


    exportToCSV() {
      /* Hay un header vacio */
      const headers ="Tipo;"+this.years.join(';')
    
      console.log("headers: ",headers)
      
      const filteredData = this.datos.filter(d => this.years.includes(d.anio));

      const valueKeys = Object.keys(this.datos[0]).filter(k => k !== "anio");
      const csvRows = [
        ...valueKeys.map(key => [this.nombres_tabla[key], ...filteredData.map(d => this.formatNumber(d[key]))].join(";")) // filas de valores
      ];
      console.log("row: ",csvRows)
      let csvRows2=csvRows.join("\n")

      const csvContent = [headers, csvRows2].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      let nombre =  this.nombre_tabla;
      nombre = nombre.toLowerCase().replace(/ /g, '_');
      //Para quitar tildes
      nombre=nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      a.download = nombre+".csv";
      a.click();
      URL.revokeObjectURL(url);
    },

    importFromCSV() {
      this.$refs.fileInput.click();
    },


    guess_delimiter(headers) {
      return headers.split(',').length > headers.split(';').length ? ',' : ';';
    },




    handleCSVUpload(event) {
      const file = event.target.files[0];
      if (file) {
        
        const reader = new FileReader();
        reader.onload = (e) => {

           const csvText = e.target.result;
          const lines = csvText.trim().split('\n');
          
         
          const delim = this.guess_delimiter(csvText.split('\n')[0])
          console.log("Delimitador: ", delim)
          //console.log("headerline: ", headerLine)
          const headers = lines[0].split(delim);
          const anios = headers.slice(1).map(Number);
          const allNumeric = headers.slice(1).every(h => !isNaN(Number(h)) && h.trim() !== "");

          /* Se necesitan todas las cabeceras numéricas */
          if (!allNumeric) {
            const nonNumericHeaders = headers.slice(1).filter(h => isNaN(Number(h)) || h.trim() === "");
            console.error("El CSV no tiene años válidos en la cabecera:", headers);
            alert(this.$t('mensajes.alerta_cabeceras_no_numericas')+"\n"+nonNumericHeaders.join(', ')+".");
            return;
          }
          const nombreInverso = Object.fromEntries(
              Object.entries(this.nombres_tabla).map(([k, v]) => [v, k])
            );
          const valores = {};
          for (let i = 1; i < lines.length; i++) {
            const cols = lines[i].split(delim);
            const tipoRaw = cols[0].trim();
            const tipo = nombreInverso[tipoRaw] ?? tipoRaw;
            console.log("Tipo: ", tipo)
            if (!this.nombres_fila.map(n => n.toLowerCase()).includes(tipo)) continue;
            anios.forEach((año, idx) => {
              if (!valores[año]) valores[año] = {};
              /* Se introuce el valor según la posición del año */
              const raw = cols[idx + 1];
              valores[año][tipo] = parseFloat(raw?.trim().replace(',', '.')) || 0;
            });
          }
          console.log("valores: ", valores)

          
          console.log("Lines -> ", lines)

          console.log("header -> ",headers)
          
          this.datos = this.datos.map(item => {
              const anio = parseInt(item.anio, 10);
              const match = valores[anio];
              if (match) {
                console.log("match: ", match)
                const updates = {};
                this.nombres_fila.forEach(nombre => {
                  // const key = nombre.toLowerCase();
                  if (match[nombre.toLowerCase()] !== undefined) updates[nombre.toLowerCase()] = match[nombre.toLowerCase()];
                });
                return { ...item, ...updates };
              }
              return item;
            });
         
         
                    
          console.log("datos data: ", this.datos)
          this.$emit("update:modelValue", this.datos);
          console.log(this.datos);
          console.log("this.ModelValue, ", this.modelValue)
        };
        reader.readAsText(file, "UTF-8");
      }
      event.target.value = ""; // Reinicia el valor del input para permitir el mismo archivo
    },


    validarCampo(fila, campo) {
      if (fila[campo] < 0) {
        fila[campo] = 0;
        alert(this.$t('El valor no puede ser negativo'));
      }
    }




  },




};
</script>

<style scoped>
#app2 {
  height: 400px;
  width: 100%;
}
revo-grid {
  height: 100%;
  width: 100%;
  font-size: 12px;
}
.contenedor-limitado{
  width: 100%;
  max-width: 80%;
  margin: 0 auto; /* Opcional: para centrar horizontalmente */
}

.tabla-container {
  max-width: 100%;
  overflow-x: auto;
  margin-top: 20px;
}

.campo,
.select-binario {
  width: 90%;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
}
.scroll-container {
  width: 100%;
  max-height: calc(100vh - 500px) !important; 
  overflow-x: auto;
  overflow-y: auto;
  border: 0px solid #e0e0e0;
  border-radius: 4px;
}
.table-wrapper {
  overflow-x: auto;
  width: 100%;
}

.value-table {
  border-collapse: collapse;
  min-width: 100%;
  font-size: 13px;
  font-family: 'Roboto', sans-serif;
}

.value-table th,
.value-table td {
  border: 1px solid #e0e0e0;
  padding: 6px 10px;
  text-align: center;
  white-space: nowrap;
  transition: background-color 0.15s ease;
}

.value-table th {
  background-color: #1976d2;
  color: #fff;
  font-weight: 600;
  letter-spacing: 0.03em;
}

.value-table th.col-odd {
  background-color: #1565c0;
}

.value-table td.col-odd {
  background-color: #eef6ff;
}

.value-table tbody td:hover {
  background-color: #bbdefb !important;
  cursor: text;
}



.label-col {
  min-width: 140px;
  text-align: left !important;
  background-color: #f5f5f5;
  font-weight: 500;
}

.year-col {
  min-width: 90px;
}

.label-cell {
  background-color: #fafafa;
}

.label-input,
.data-input {
  border: none;
  background: transparent;
  width: 100%;
  text-align: center;
  font-size: 13px;
  outline: none;
  font-family: inherit;
}

.label-input {
  text-align: left;
  font-weight: 500;
}

.label-input:focus,
.data-input:focus {
  background-color: #e3f2fd;
  border-radius: 3px;
}
</style>

